var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.modelStyle.width,
        visible: _vm.visible,
        bodyStyle: _vm.bodyStyle,
        switchFullscreen: _vm.switchFullscreen
      },
      on: {
        cancel: _vm.handleCancel,
        setInnerFullscreen: _vm.setInnerFullscreen
      }
    },
    [
      _c(
        "template",
        { slot: "footer" },
        [
          _vm.source == "UserAnnouncementlist" && _vm.record.needReply == "1"
            ? _c(
                "div",
                [
                  _c("a-textarea", {
                    staticStyle: {
                      width: "100%",
                      "margin-right": "8px",
                      "margin-bottom": "8px"
                    },
                    attrs: {
                      disabled: !!_vm.sysAnnouncementSend.replyUserId,
                      maxLength: 150
                    },
                    model: {
                      value: _vm.sysAnnouncementSend.replyContent,
                      callback: function($$v) {
                        _vm.$set(_vm.sysAnnouncementSend, "replyContent", $$v)
                      },
                      expression: "sysAnnouncementSend.replyContent"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.source == "UserAnnouncementlist" &&
          _vm.record.needReply == "1" &&
          _vm.sysAnnouncementSend.replyUserId
            ? _c("span", { staticStyle: { "padding-right": "10px" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.language["system.announcement.replyTime"]) +
                    " : " +
                    _vm._s(_vm.sysAnnouncementSend.replyTime) +
                    "\n      "
                )
              ])
            : _vm._e(),
          _vm.source == "UserAnnouncementlist" &&
          _vm.record.needReply == "1" &&
          !_vm.sysAnnouncementSend.replyUserId
            ? _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.replyAnnouncement }
                },
                [_vm._v(_vm._s(_vm.language["common.reply"]))]
              )
            : _vm._e(),
          _c("a-button", { key: "back", on: { click: _vm.handleCancel } }, [
            _vm._v(_vm._s(_vm.language["common.closeButton"]))
          ]),
          _vm.record.openType === "url"
            ? _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.toHandle } },
                [_vm._v(_vm._s(_vm.language["announcement.dealWith"]))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "a-card",
        { staticClass: "daily-article", attrs: { loading: _vm.loading } },
        [
          _c("a-card-meta", {
            attrs: {
              title: _vm.record.titile,
              description:
                _vm.language["announcement.publisher"] +
                "：" +
                (_vm.record.sender
                  ? _vm.record.sender
                  : _vm.language["common.not"]) +
                " | " +
                _vm.language["announcement.publishTime"] +
                "：" +
                (_vm.record.sendTime
                  ? _vm.record.sendTime
                  : _vm.language["common.not"])
            }
          }),
          _c("a-divider"),
          _c("span", { staticStyle: { margin: "10px 0px" } }, [
            _vm._v(_vm._s(_vm.language["announcement.msgAbstract"]) + ":"),
            _c("span", {
              staticClass: "article-content",
              domProps: { innerHTML: _vm._s(_vm.record.msgAbstract) }
            })
          ]),
          _c("span", {
            staticClass: "article-content",
            domProps: { innerHTML: _vm._s(_vm.record.msgContent) }
          }),
          _vm.record.fileList && _vm.record.fileList.length > 0
            ? _c(
                "div",
                [
                  _c("a-divider"),
                  _c("span", [
                    _vm._v(_vm._s(_vm.language["selfCheck.file"]) + "：")
                  ]),
                  _vm._l(_vm.record.fileList, function(file) {
                    return _c(
                      "div",
                      { key: file.id, attrs: { value: file.filePath } },
                      [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.announcementDownloadFile(file)
                              }
                            }
                          },
                          [_vm._v(_vm._s(file.fileName))]
                        )
                      ]
                    )
                  })
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }